import { useCallback } from 'react'
import { useModals } from 'almanac-ui/Modal'
import { useRootStore } from 'stores/RootStore'
import { PurchaseContentCreditsModal } from 'components/Settings/TieredBilling/components/AutopilotDetails/components/PurchaseContentCreditsModal/PurchaseContentCreditsModal'
import { AutopilotPlansModal } from 'components/Settings/Workspace/AutopilotPlans/AutopilotPlansModal'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { StripePrice } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'

interface PurchaseContentCreditsModalProps {
  price: StripePrice
  defaultBatchCount?: number
  closeOnSuccess?: boolean
  onSuccess?: () => void
  skipRedirect?: boolean
  [key: string]: any
}

interface ModalOptions {
  newStack?: boolean
  [key: string]: any
}

export const usePurchaseContentCreditsModal = () => {
  const { openModal } = useModals()
  const { tierUsageStore } = useRootStore()
  const { currentSubscription } = tierUsageStore

  const openPurchaseModal = useCallback(
    (props: PurchaseContentCreditsModalProps, options?: ModalOptions) => {
      if (currentSubscription?.status === 'active') {
        openModal(PurchaseContentCreditsModal, props, options)
      } else {
        const currentPlanKey =
          currentSubscription?.plan === PaymentPlanKey.BlazeAutopilotGrowth
            ? PaymentPlanKey.BlazeAutopilotGrowth
            : PaymentPlanKey.BlazeAutopilotStarter
        const plan = tierUsageStore.autopilotPlans.find((p) => p.key === currentPlanKey)
        if (plan) {
          openModal(
            AutopilotPlansModal,
            {
              initialStep: 'checkout',
              initialPlanAndPrice: { plan },
              skipRedirect: props.skipRedirect,
            },
            options,
          )
        }
      }
    },
    [currentSubscription, openModal, tierUsageStore.autopilotPlans],
  )

  return openPurchaseModal
}
